








































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { Employee } from '@/model/companyStructure/Employee'
import BooleanCellRenderer from '@/components/cell-renderer/BooleanCellRenderer.vue'
import EmployeeSelectorDialog from '@/components/planning/shift/ShiftEditorEmployeeSelectorDialog.vue'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import {
  GET_SELECTED_UI_LANGUAGE, PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS,
  PLANNING_ASSISTANT_GET_COMPANY_FILTER, PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING,
  PLANNING_ASSISTANT_GET_END_DATE, PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY, PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY,
  PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM,
  PLANNING_ASSISTANT_GET_START_DATE, PLANNING_ASSISTANT_GET_TASK_LIST
} from '@/store/getter-types'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import {
  CREATE_SHIFT_NEW,
  FETCH_EMPLOYEE_PLACEHOLDER_LIST, PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST,
  PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID,
  PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE, PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY
} from '@/store/action-types'
import {
  AdditionalFieldsPayloadItem,
  CompanyFilterValue,
  CreateShiftPayload, FetchEmployeePlaceholderListPayload,
  PlanningAssistantPeriodicityPayload
} from '@/types/payload'
import { ShiftAvailability } from '@/types/enums'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import * as planningService from '@/services/planning-service'
import { PeriodicityPlannedEmployee } from '@/types'
import moment from 'moment'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import { Task } from '@/model/planning/Task'
import { EmployeePlaceholder } from '@/model/planning/EmployeePlaceholder'
import { Address } from '@/model/planning/Address'
import { CreateShiftNewResponse } from '@/types/service-response'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import EmployeeChangeCellRenderer from '@/components/cell-renderer/EmployeeChangeCellRenderer.vue'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  gridOptions: GridOptions
  colDefWithChange: any[]
  selectedEmployeeList: Array<Employee>
  gridFrameworkComponents: Object
  showEmployeeSelector: boolean
  currentSelectedRowData: any
  overlayNoRowsTemplate: string
  panel: number[]
  selectedItem: PeriodicityPlannedEmployee | undefined
  loading: boolean
  isExpansionPanelReadonly: boolean
  periodicitySelectedRow: string | undefined
  changeEmployee: PlannedEmployee | undefined
  rowSelection: string
  placeholderList: EmployeePlaceholder[]
}

export default Vue.extend({
  name: 'ShiftEditorEmployeeFreePlanning',

  components: {
    AgGridVue,
    EmployeeSelectorDialog
  },

  props: {
    editShift: Object as () => EditShiftPlan | undefined,
    projectSerieTemplate: Object as () => ShiftTemplate | undefined,
    selectedAddress: Object as () => Address | undefined,
    selectedProject: Object as () => PlanningLookupProject | null,
    isEditProject: Boolean,
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('planningPage.name').toString(), width: 400, field: 'name' },
          { headerName: this.$t('planningPage.capacity').toString(), field: 'capacity', width: 120, cellStyle: { 'text-align': 'right' } },
          {
            headerName: this.$t('planningPage.jumper').toString(),
            field: 'isFloater',
            cellRenderer: 'booleanRenderer',
            width: 120
          },
          { headerName: this.$t('planningPage.planningGroup').toString(), field: 'planingGroupName', width: 250 },
        ],
      },
      colDefWithChange: [
        {
          headerName: '',
          field: 'name',
          cellRenderer: 'employeeChangeCellRenderer',
          cellRendererParams: {
            //@ts-ignore
            openEmployeeDialog: this.openEmployeeDialog.bind(this)
          },
          width: 100
        },
        { headerName: this.$t('planningPage.name').toString(), field: 'name', width: 400 },
        { headerName: this.$t('planningPage.capacity').toString(), field: 'capacity', width: 120, cellStyle: { 'text-align': 'right' } },
        {
          headerName: this.$t('planningPage.jumper').toString(),
          field: 'isFloater',
          cellRenderer: 'booleanRenderer',
          width: 120
        },
        { headerName: this.$t('planningPage.planningGroup').toString(), field: 'planingGroupName', width: 250 },
      ],

      selectedEmployeeList: [],

      gridFrameworkComponents: {
        employeeChangeCellRenderer: EmployeeChangeCellRenderer,
        booleanRenderer: BooleanCellRenderer
      },

      showEmployeeSelector: false,
      currentSelectedRowData: undefined,
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      panel: [0],
      selectedItem: undefined,
      loading: false,
      isExpansionPanelReadonly: false,
      periodicitySelectedRow: undefined,
      changeEmployee: undefined,
      rowSelection: 'multiple',
      placeholderList: []
    }
  },

  watch: {
    isEditProject (newVal: boolean): void {
      if(newVal) {
        //@ts-ignore
        this.gridOptions.api.setColumnDefs(this.colDefWithChange)
      }
    }
  },

  computed: {
    dateStart (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
    },

    plannedEmployeeList (): PlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    isRemoveButtonDisabled (): boolean {
      return !this.currentSelectedRowData
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    isEdittingFreeShiftSerie (): boolean {
      return !(this.editShift && this.editShift.shiftName)
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isEditingQcqShiftSerie (): boolean {
      return !!(this.editShift && this.editShift.typeOfShift === 'QCQ Shift')
    }
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    floaterIconColor (employee: PlannedEmployee): string {
      const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
      const result: boolean = employees.some((item: Employee) => item.id === employee.id)
      return result ? 'red' : 'green'
    },

    floaterIcon (employee: PlannedEmployee): string {
      const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
      const result: boolean = employees.some((item: Employee) => item.id === employee.id)
      return result ? 'clear' : 'check'
    },

    onAddEmployeeButtonClick (item?: PeriodicityPlannedEmployee): void {
      this.isExpansionPanelReadonly = true
      this.rowSelection = 'multiple'
      this.showEmployeeSelector = true
      if (item && item.date) {
        this.selectedItem = item
        this.periodicitySelectedRow = _.findIndex(this.periodicityPlannedEmployeeList, { date: item.date }).toString()
      }
    },

    onChangeEmployeeButtonClick (item: PeriodicityPlannedEmployee, employee: PlannedEmployee): void {
      this.rowSelection = 'single'
      this.showEmployeeSelector = true
      this.changeEmployee = employee
      this.selectedItem = item
      this.periodicitySelectedRow = _.findIndex(this.periodicityPlannedEmployeeList, { date: item.date }).toString()
    },

    openEmployeeDialog (): void {
      this.rowSelection = 'single'
      this.showEmployeeSelector = true
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowData = params.node.data
    },

    onRemoveEmployeeButtonClick (): void {
      let plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      this.plannedEmployeeList.splice(
        _.findIndex(this.plannedEmployeeList, { id: this.currentSelectedRowData.id }), 1)
      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      this.currentSelectedRowData = undefined
    },

    onCloseEmployeeSelector (): void {
      this.loading = false
      this.isExpansionPanelReadonly = false
      this.showEmployeeSelector = false
      this.periodicitySelectedRow = undefined
    },

    onAddEmployeeListToSelection (employeeList: EmployeeAvailableForPlanning[]): void {
      if (!this.isEdittingSerie && this.isEditProject) {
        //Edit one project from serie
        const number: number | undefined = this.plannedEmployeeList[0].number
        const selectedEmployeeList: PlannedEmployee[] = employeeList
            .map((item: EmployeeAvailableForPlanning): PlannedEmployee => {
              return new PlannedEmployee(
                  item.id,
                  item.name,
                  item.capacity,
                  item.isFloater,
                  item.competenceName,
                  '',
                  this.dateStart,
                  this.dateEnd,
                  item.planingGroupName,
                  undefined,
                  undefined,
                  undefined,
                  number
              )
            })

        const newEmployeeList: PlannedEmployee[] = selectedEmployeeList

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, newEmployeeList)

        this.onCloseEmployeeSelector()

      } else if (!this.isEdittingSerie && !this.changeEmployee) {
        // Add employees normal

        const selectedEmployeeList: PlannedEmployee[] = employeeList
          .map((item: EmployeeAvailableForPlanning): PlannedEmployee => {
            return new PlannedEmployee(
              item.id,
              item.name,
              item.capacity,
              item.isFloater,
              item.competenceName,
                '',
              this.dateStart,
              this.dateEnd,
              item.planingGroupName,
              undefined,
              undefined,
              undefined,
              undefined
            )
          })

        const newEmployeeList: PlannedEmployee[] = ([] as PlannedEmployee[]).concat(this.plannedEmployeeList, selectedEmployeeList)

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, newEmployeeList)

        if (!this.periodicity.isUnique) {
          this.createShift()
        } else {
          this.onCloseEmployeeSelector()
        }
      } else if (this.changeEmployee) {
        // Change employee

        const selectedEmployeeList: PlannedEmployee[] = employeeList
          .map((item: EmployeeAvailableForPlanning): PlannedEmployee => {
            return new PlannedEmployee(
              item.id,
              item.name,
              item.capacity,
              item.isFloater,
              this.changeEmployee!.competenceName,
              this.changeEmployee!.educationName,
              this.changeEmployee!.start,
              this.changeEmployee!.end,
              item.planingGroupName,
              this.changeEmployee!.taskName,
              this.changeEmployee!.note,
              this.changeEmployee!.taskId,
              this.changeEmployee!.number,
              this.changeEmployee!.detailID
            )
          })

        let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        const index: number = this.periodicityPlannedEmployeeList.indexOf(this.selectedItem!)
        const employeeIndex: number = this.periodicityPlannedEmployeeList[index].employeeList.indexOf(this.changeEmployee)
        localPlannedEmployeeList[index].employeeList.splice(employeeIndex, 1, selectedEmployeeList[0])

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
        this.onCloseEmployeeSelector()

      } else {
        // Add employees serie

        let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        const index: number = this.periodicityPlannedEmployeeList.indexOf(this.selectedItem!)

        const hourStart = parseInt(moment(this.dateStart).format('HH'))
        const hourEnd = parseInt(moment(this.dateEnd).format('HH'))
        const minuteStart = parseInt(moment(this.dateStart).format('mm'))
        const minuteEnd = parseInt(moment(this.dateEnd).format('mm'))

        let updatedStartDate: any
        let updatedEndDate: any
        let employeeWithMaxNumber: PlannedEmployee | undefined

        if (localPlannedEmployeeList[index].employeeList[0]) {
          updatedStartDate = moment(localPlannedEmployeeList[index].employeeList[0].start).hours(hourStart).minutes(minuteStart).toDate()
          updatedEndDate = moment(localPlannedEmployeeList[index].employeeList[0].end).hours(hourEnd).minutes(minuteEnd).toDate()
          employeeWithMaxNumber = _.maxBy(localPlannedEmployeeList[index].employeeList, 'number')
        } else {
          const foundDetail: ShiftEmployeeDetails | undefined = this.editShift!.details.find((item: ShiftEmployeeDetails) =>
            moment(item.dateStart).format('DD.MM.YYYY') === localPlannedEmployeeList[index].date)
          updatedStartDate = moment(foundDetail!.dateStart).hours(hourStart).minutes(minuteStart).toDate()
          updatedEndDate = moment(foundDetail!.dateEnd).hours(hourEnd).minutes(minuteEnd).toDate()
        }

        let row: number = 0
        if (employeeWithMaxNumber && employeeWithMaxNumber!.number) {
          row = employeeWithMaxNumber!.number
        }

        const selectedEmployeeList: PlannedEmployee[] = employeeList
          .map((item: EmployeeAvailableForPlanning): PlannedEmployee => {
            row++
            return new PlannedEmployee(
              item.id,
              item.name,
              item.capacity,
              item.isFloater,
              item.competenceName,
              '',
              updatedStartDate,
              updatedEndDate,
              item.planingGroupName,
              undefined,
              undefined,
              undefined,
              row
            )
          })

        selectedEmployeeList.forEach((employee: PlannedEmployee) => {
          localPlannedEmployeeList[index].employeeList.push(employee)
        })

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
        this.onCloseEmployeeSelector()
      }
    },

    onPeriodicityRemoveEmployeeButtonClick (idx: number, employee: PlannedEmployee) {
      if (this.isEdittingFreeShiftSerie) {
        let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        localPlannedEmployeeList[idx].employeeList.splice(
          _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id }), 1)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      } else {
        this.fetchEmployeePlaceholderList(this.projectSerieTemplate ? this.projectSerieTemplate.id : undefined).then(() => {
        const filteredPlaceHolder: EmployeePlaceholder | undefined = this.placeholderList.find((item: EmployeePlaceholder) => item.number === employee.number)
        const avatar: PlannedEmployee = new PlannedEmployee(
          undefined,
          '',
          undefined,
          false,
          employee.competenceName,
          employee.educationName,
          employee.start,
          employee.end,
          filteredPlaceHolder ? filteredPlaceHolder.planningGroupName : undefined,
          filteredPlaceHolder ? filteredPlaceHolder.taskName : undefined,
          undefined,
          filteredPlaceHolder ? filteredPlaceHolder.taskId : undefined,
          employee.number,
          employee.detailID
        )

        let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        localPlannedEmployeeList[idx].employeeList.splice(
          _.findIndex(localPlannedEmployeeList[idx].employeeList, { detailID: employee.detailID }), 1, avatar)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      })
      }

    },

    async fetchEmployeePlaceholderList (templateItemId: number | undefined): Promise<void> {
      if(templateItemId) {
        const payload: FetchEmployeePlaceholderListPayload = {
          shiftTemplateId: templateItemId
        }

        if (this.placeholderList.length === 0) {
          this.placeholderList = await this.$store.dispatch(FETCH_EMPLOYEE_PLACEHOLDER_LIST, payload)
        } else {
          return
        }
      } else {
        return
      }
    },

    async createShift (): Promise<void> {
      // Create periodicity free shift

      const filterValue: CompanyFilterValue = this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
      const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
      const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
      const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
      const shiftTemplate: ShiftTemplate | undefined = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]
      const additionalFields: AdditionalFieldsPayloadItem[] = this.$store.getters[PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS]
      const plannedEmployeeList: PlannedEmployee[] = this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]

      const newShiftPayload: CreateShiftPayload = planningService.composeCreateNewShiftPayload(
          filterValue!.profitCenter!.id,
          filterValue!.department!.id,
          this.$store.state.currentUser!.id,
          this.$store.state.selectedUiLanguage!.syzId,
          dateStart,
          dateEnd,
          periodicity,
          availability,
          shiftTemplate,
          this.selectedAddress ? this.selectedAddress.id : null,
          this.selectedProject ? this.selectedProject.id : null,
          additionalFields,
          plannedEmployeeList
      )

      try {
        this.loading = true
        const newShiftData: CreateShiftNewResponse = await this.$store.dispatch(CREATE_SHIFT_NEW, { newShiftPayload: newShiftPayload })
        this.loading = false
        if (!newShiftData.IsError && newShiftData && newShiftData.ProjectSeries) {
          const response: EditShiftPlan[] = EditShiftPlan.createListFromResponse(newShiftData.ProjectSeries)

          this.$store.dispatch(PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID, newShiftData.ProjectSeries[0].ProjektSerieID)
          this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, AdditionalGroup.createFromResponse(newShiftData.ProjectSeries[0].Zusatzfelder))

          const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
          const selectedEmployeeList = response[0].details
              .map((detail: ShiftEmployeeDetails): PlannedEmployee => {
                const task: Task = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]
                    .find((item: Task) => item.id === detail.taskId)
                const employee: EmployeeAvailableForPlanning | undefined = availableEmployeeList.find((employee: EmployeeAvailableForPlanning) => employee.id === detail.employeeId)
                return new PlannedEmployee(
                    employee ? employee.id : undefined,
                    employee ? employee!.name : '',
                    employee ? employee!.capacity : undefined,
                    employee ? employee!.isFloater : false,
                    employee ? employee!.competenceName : '',
                    '',
                    new Date(detail.dateStart),
                    new Date(detail.dateEnd),
                    employee ? employee!.planingGroupName : undefined,
                    task ? task.name : undefined,
                    detail.note ? detail.note : undefined,
                    detail.taskId ? detail.taskId : undefined,
                    detail.row ? detail.row : undefined,
                    detail.detailId ? detail.detailId : undefined,
                    detail.projectId ? detail.projectId : undefined
                )
              })

          let data: PeriodicityPlannedEmployee[] = []
          selectedEmployeeList.forEach((item: PlannedEmployee) => {
            let foundItem: PeriodicityPlannedEmployee | undefined

            if (data.length > 0) {
              foundItem = data.find((i: PeriodicityPlannedEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
            }

            if (foundItem) {
              foundItem.employeeList.push(item)
            } else {
              data.push({
                date: moment(item.start).format('DD.MM.YYYY'),
                projectId: item.projectId ? item.projectId : null,
                employeeList: [item]
              })
            }
          })

          data = _.sortBy(data, [function (o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD'); }])

          this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)

          if (response[0].fixed === 'True') {
            this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Fixed)
          } else {
            this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Temporary)
          }

          this.$store.dispatch(PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE, true)
          this.onCloseEmployeeSelector()
        } else {
          this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, [])
        }
      } catch {
        this.loading = false
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, [])
      }
    }
  }
})
